// AeternityChat sends buyers here with ?contact_ref=<id> (contactId accepted as
// a fallback). We keep it so the order we create can carry it, and the backend
// can return it to AeternityChat once the payment succeeds. The id is
// case-sensitive — never change its case.
const ID_KEY = "aeternityContactId";
const EXPIRY_KEY = "aeternityContactIdExpiry";
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
const VALID_ID = /^[A-Za-z0-9_-]{1,128}$/;

export function captureContactId() {
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("contact_ref") || params.get("contactId");
    const id = raw ? raw.trim() : "";
    if (VALID_ID.test(id)) {
      localStorage.setItem(ID_KEY, id);
      localStorage.setItem(EXPIRY_KEY, String(Date.now() + THIRTY_DAYS_MS));
    }
  } catch {
    // storage unavailable (private mode) — checkout simply proceeds without it
  }
}

export function getContactId() {
  try {
    const expiry = parseInt(localStorage.getItem(EXPIRY_KEY) || "0", 10);
    if (expiry && Date.now() > expiry) {
      localStorage.removeItem(ID_KEY);
      localStorage.removeItem(EXPIRY_KEY);
      return null;
    }
    const id = localStorage.getItem(ID_KEY);
    return id && VALID_ID.test(id) ? id : null;
  } catch {
    return null;
  }
}
